import { render, staticRenderFns } from "./UserCarousels.vue?vue&type=template&id=dac01b44&scoped=true"
import script from "./UserCarousels.vue?vue&type=script&lang=js"
export * from "./UserCarousels.vue?vue&type=script&lang=js"
import style0 from "./UserCarousels.vue?vue&type=style&index=0&id=dac01b44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac01b44",
  null
  
)

export default component.exports